import { object, array, string } from "yup";

export default object()
  .required()
  .shape({
    meta_title: string().required(),
    meta_description: string().required()
  });
